import styles from './styles.module.scss'

const ScheduleACallImage = () => {
    return <div className={`${styles['schedule-a-call-image']}`}></div>
}

export default ScheduleACallImage
